<div class="comment-compact-card" [class.comment-compact-card--selected]="selected">
  @if (comment) {
    <div class="comment-header">
      @if (comment.titlePinned) {
        <span
          class="title"
          [class.margin-bottom]="comment?.title && (comment.summary || comment.content)"
        >
          {{ comment?.title }}
        </span>
      }
    </div>
    @if (comment?.summary && comment?.summaryPinned) {
      <div class="comment-text-content">
        {{ comment.summary }}
      </div>
    }
  }
</div>
